import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white" data-id="element-45">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="bg-brand-light border-2 border-brand-gold/30 rounded-[2rem] p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12 relative overflow-hidden" data-id="element-47">
          {/* Gold glow effect */}
          <div className="absolute -top-24 -left-24 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-48"></div>

          <div className="flex-shrink-0 relative" data-id="element-49">
            <div className="w-32 h-32 bg-white rounded-full flex items-center justify-center shadow-xl border-4 border-brand-gold/20" data-id="element-50">
              <ShieldCheck className="w-16 h-16 text-brand-gold" data-id="element-51" />
            </div>
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-brand-gold text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap shadow-md" data-id="element-52">
              GARANTÍA DE 30 DÍAS
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-53">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-brand-dark mb-4" data-id="element-54">
              Tu inversión está 100% protegida
            </h3>
            <p className="text-brand-muted mb-6 leading-relaxed" data-id="element-55">
              Estoy tan segura de que este método cambiará tu vida que quiero
              asumir todo el riesgo. Descarga la guía, lee el Script de Oro y
              aplica el plan de 14 días. Si no sientes que vale 10 veces lo que
              pagaste, envíame un correo y te devuelvo tus $6.36. Sin preguntas.
              Sin rencores.
            </p>
            <p className="font-heading italic text-brand-primary font-bold text-lg" data-id="element-56">
              No tienes absolutamente nada que perder y una nueva vida que
              ganar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}